<template>
  <div class="app-container">
    <div style="padding-top:25px">
      <label>{{ $t('route.menu_store_shipment_list') }}</label>
      <p>{{ $t('orderLine.selectShipmentListDate') }}</p>
      <el-select :value="shipmentDate" :placeholder="$t('orderLine.shipmentListDate')" @input="handleDateSelected">
        <el-option v-for="item in shipmentDates" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <div style="float:right;">
        <editor-button
          :loading="loading"
          :icon-only="false"
          button-translation="common.downloadPDF"
          action="primary"
          @click="exportAsPDF()"
        />
      </div>
      <crud-table
        entity="StoreOrderLineShipment"
        :columns="columns"
        :show-action-icons-in-list="true"
        :always-show-pagination="true"
        :on-row-dbl-click="() => {}"
        :show-close="false"
        :show-clear-filter="false"
        :load-data-on-created="false"
        :persist-state="false"
        :filters="orderFilter"
        :custom-actions="getCustomListActions()"
      />
    </div>
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
import EditorButton from '@/components/crud/EditorButton';
import orderlistMixin from './../orderlist-mixin';
import { toDutchDateString } from '@/utils/date';

export default {
  components: {
    CrudTable,
    EditorButton
  },
  mixins: [orderlistMixin],
  data() {
    return {
      loading: false,
      shipmentDate: null,
      shipmentDates: [],
      columns: [
        { field: 'id', label: 'orderLine.ticketNumber', width: '150px' },
        { field: 'customerReference', label: 'orderLine.customerReference', width: '130px' },
        { field: 'orderedAt', label: 'orderLine.orderDate', minWidth: '110px', type: 'date', filter: { type: 'date' } },
        { field: 'consumerName', label: 'orderLine.consumerName', minWidth: '160px' },
        {
          field: 'transportOrderLineSubstatusName',
          label: 'orderLine.orderLineStatus',
          minWidth: '100px',
          filter: {
            type: 'select',
            options: this.orderLineStatuses,
            valueField: 'id',
            labelField: 'name'
          }
        },
        {
          field: 'productGroupDescription',
          label: 'orderLine.productGroup',
          minWidth: '120px',
          filter: {
            type: 'select',
            options: this.productGroups,
            valueField: 'description',
            labelField: 'description'
          }
        },
        { field: 'fabricName', label: 'orderLine.fabricName', minWidth: '140px' },
        {
          field: 'numberOfParcels',
          label: 'orderLine.numberOfParcels',
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  computed: {
    dateTimeFormat() {
      return this.$store.getters.dateFormat;
    },
    orderFilter() {
      return {
        shipmentDate: toDutchDateString(this.shipmentDate),
        forShipmentList: true
      };
    }
  },
  created() {
    this.$store.dispatch('storeOrderLineShipment/getDistinctShipmentDates').then(dates => {
      if (dates.length) {
        this.shipmentDate = dates[0];
      }
      this.shipmentDates = dates.map(d => {
        return { value: d, label: toDutchDateString(d) };
      });
    });
  },
  methods: {
    handleDateSelected(date) {
      this.shipmentDate = date;
    },
    exportAsPDF() {
      this.loading = true;
      this.$store
        .dispatch('storeOrderLineShipment/exportAsPDF', {
          shipmentDate: toDutchDateString(this.shipmentDate)
        })
        .then(data => {
          this.previewFile(data);
        })
        .finally(() => (this.loading = false));
    },
    previewFile(blob, target = '_blank') {
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, target);
    }
  }
};
</script>
